<app-dashboard-card>
  <ng-container card-title-icon>
    <mat-icon>star</mat-icon>
  </ng-container>

  <ng-container card-title-content>
    <div class="header-container">
      <h2>Últimos Eventos</h2>
      <a class="see-all" [routerLink]="['/my-events']">> Ver todos</a>
    </div>
  </ng-container>

  <ng-container card-content>
    <div>
      @if (myEvents) {
        @for (event of myEvents; track event.id) {
          <app-event-table-row [event]="event" />
        } @empty {
          <p>Você ainda não possui nenhum evento cadastrado</p>
        }
      } @else {
        <p-skeleton height="20rem" />
      }
    </div>
  </ng-container>
</app-dashboard-card>
